// Mocks for /api/secure/me/goals/*

import { delay } from './index'

const STORAGE_KEY = 'patientPortal.mock.goals.v1'

function readStore() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}')
  } catch (e) {
    return {}
  }
}
function writeStore(s) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(s))
  } catch (e) {
    /* ignore */
  }
}

function seedFor(profile) {
  if (!profile) return { goals: [], checkIns: [] }
  const isSelf = profile.relation === 'SELF'
  const goals = isSelf
    ? [
        {
          id: 'goal_sleep',
          title: 'Sleep 7+ hours nightly',
          description: 'Lights out by 11. Aim for 7 nights/week.',
          targetValue: 7,
          currentValue: 4,
          unit: 'nights/week',
          progressPct: 57,
          setBy: 'Dr. Meera Iyer',
          status: 'ACTIVE',
        },
      ]
    : [
        {
          id: 'goal_bp',
          title: 'BP under 130/85',
          description: 'Average across morning readings, weekly.',
          targetValue: 7,
          currentValue: 3,
          unit: 'in-range readings/week',
          progressPct: 43,
          setBy: 'Dr. Rao',
          status: 'ACTIVE',
        },
      ]
  return { goals, checkIns: [] }
}

function ensure(profile) {
  const store = readStore()
  if (!store[profile.id]) {
    store[profile.id] = seedFor(profile)
    writeStore(store)
  }
  return { store, prof: store[profile.id] }
}

function progress(current, target) {
  if (target == null || target === 0 || current == null) return null
  return Math.max(0, Math.min(100, Math.round((current / target) * 100)))
}

export async function list(profile, status) {
  await delay()
  if (!profile) return []
  const { prof } = ensure(profile)
  return prof.goals.filter((g) => !status || g.status === status)
}

export async function create(profile, body) {
  await delay()
  if (!profile) return null
  const { store, prof } = ensure(profile)
  const goal = {
    id: `goal_${Date.now()}`,
    title: body.title,
    description: body.description || null,
    targetValue: body.targetValue ?? null,
    currentValue: body.currentValue ?? 0,
    unit: body.unit || null,
    progressPct: progress(body.currentValue ?? 0, body.targetValue),
    setBy: body.setBy || 'SELF',
    status: 'ACTIVE',
  }
  prof.goals.push(goal)
  store[profile.id] = prof
  writeStore(store)
  return goal
}

export async function update(profile, id, patch) {
  await delay()
  if (!profile) return null
  const { store, prof } = ensure(profile)
  const idx = prof.goals.findIndex((g) => g.id === id)
  if (idx === -1) return null
  prof.goals[idx] = { ...prof.goals[idx], ...patch }
  prof.goals[idx].progressPct = progress(prof.goals[idx].currentValue, prof.goals[idx].targetValue)
  store[profile.id] = prof
  writeStore(store)
  return prof.goals[idx]
}

export async function checkIn(profile, id, body) {
  await delay()
  if (!profile) return null
  const { store, prof } = ensure(profile)
  const idx = prof.goals.findIndex((g) => g.id === id)
  if (idx === -1) return null
  if (body?.value != null) {
    prof.goals[idx].currentValue = body.value
    prof.goals[idx].progressPct = progress(body.value, prof.goals[idx].targetValue)
  }
  prof.checkIns.push({
    id: `ci_${Date.now()}`,
    goalId: id,
    value: body?.value ?? null,
    note: body?.note || null,
    checkedInAt: new Date().toISOString(),
  })
  store[profile.id] = prof
  writeStore(store)
  return prof.goals[idx]
}

export function __resetGoalsMock() {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch (e) {
    /* ignore */
  }
}
